import api from './api';
import { cacheMapCenter, requestBrowserPosition } from '../utils/mapCenter';

export interface LocationResult {
  id: string;
  label: string;
  address: string;
  lat: number;
  lng: number;
  city?: string;
  state?: string;
  country?: string;
  countryCode?: string;
  postalCode?: string;
  type?: string;
}

export async function searchLocations(query: string, options?: {
  lat?: number; lng?: number; city?: string; limit?: number;
}): Promise<LocationResult[]> {
  const res = await api.get('/maps/locations/search', {
    params: { q: query, lat: options?.lat, lng: options?.lng, city: options?.city, limit: options?.limit },
  });
  return res.data.data || [];
}

export async function reverseGeocode(lat: number, lng: number): Promise<LocationResult | null> {
  const res = await api.get('/maps/locations/reverse', { params: { lat, lng } });
  return res.data.data || null;
}

export async function nearbyLocations(lat: number, lng: number, limit = 6): Promise<LocationResult[]> {
  const res = await api.get('/maps/locations/nearby', { params: { lat, lng, limit } });
  return res.data.data || [];
}

export function getCurrentPosition(): Promise<{ lat: number; lng: number }> {
  return requestBrowserPosition(12000).then((pos) => {
    cacheMapCenter(pos);
    return pos;
  });
}
